var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentContainer',[_c('div',{staticClass:"teacher-students-list-view"},[_c('div',{staticClass:"teacher-students-list-view__header"},[_c('div',{staticClass:"u-text-h2"},[_vm._v("Students")])]),_c('StudentsList'),_c('GiveCoins')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }